import PopeyeModal from '../popeye-modal.class'

export default class CorrectModal extends PopeyeModal {
  modal = {
    template: require('./correct.modal.html'),
    /** @ngInject */
    controller: function ($scope, item) {
      $scope.item = item
    },
  }
}
